/** Page size for the organisation list. */
export const ORG_DEFAULT_PAGE_SIZE = 10;

/** Page size for the user table on the organisation details page (client-side paging). */
export const ORG_USER_PAGE_SIZE = 10;

/** Debounce for the organisation name search, matching the E4H Management Hub. */
export const ORG_SEARCH_DEBOUNCE_MS = 350;
